<app-header [hideBackButton]="false"></app-header>
<ion-content>
  <ion-list
    *ngIf="(moreVM$ | async) as moreVM"
    data-cy="more-actions-list"
    class="list-more-mobile"
    lines="none"
  >
    <div class="group">
      <ion-item
        *ngIf="showBusinessAnalytics$ | async"
        [disabled]="isGuestUser"
        class="btm-line"
        data-cy="more-actions-list-item-farmers-report"
        detail="false"
        (click)="routeTo([PATHS.CUSTOMER_REPORTING])"
      >
        <ion-label>{{ 'i18n.moxe-links.ba' | translate }}</ion-label>
      </ion-item>
      <ion-item
        *ngIf="moreVM?.showInventory"
        class="btm-line"
        data-cy="more-actions-list-item-inventory"
        (click)="routeTo([PATHS.INVENTORY])"
      >
        <ion-label>{{ 'i18n.moxe-links.inventory' | translate }}</ion-label>
      </ion-item>
      <ion-item
        [hidden]="moreVM?.hideInvoiceAndPayments"
        class="btm-line"
        data-cy="more-actions-list-item-payments"
        (click)="routeToPayments()"
      >
        <ion-label>{{ this.invoicePageTitle | translate }}</ion-label>
      </ion-item>
      <ion-item
        *ngIf="moreVM?.takeoutOption"
        class="btm-line"
        data-cy="more-actions-list-item-rebates"
        (click)="routeToRebates(moreVM?.takeoutOption)"
      >
        <ion-label
          >{{ 'i18n.moxe-links.incentivePrograms' | translate }}</ion-label
        >
      </ion-item>
      <ion-item
        class="btm-line"
        data-cy="more-actions-list-item-farmers-report"
        detail="false"
        href="https://www.usfoods.com/our-services/business-trends/farmers-report.html"
      >
        <ion-label>{{ 'i18n.moxe-links.farmerReport' | translate }} </ion-label>
        <ion-icon
          src="assets/icon/external-link-green.svg"
          class="external-link"
          slot="end"
        ></ion-icon>
      </ion-item>
      <ion-item
        class="btm-line"
        data-cy="more-actions-list-item-premier-member-food-forum"
        detail="false"
        href="https://premierforum.usfoods.com"
        *ngIf="isPremierUser$ | async"
      >
        <ion-label
          >{{ 'i18n.moxe-links.premierMemberFoodForum' | translate }}
        </ion-label>
        <ion-icon
          src="assets/icon/external-link-green.svg"
          class="external-link"
          slot="end"
        ></ion-icon>
      </ion-item>

      <ion-item
        *ngIf="moreVM?.showMoxeMpp"
        class="btm-line"
        data-cy="more-actions-list-item-moxe-mpp"
        (click)="onMoxeMppClick()"
      >
        <ion-label>{{ 'i18n.moxe-links.moxeMpp' | translate }}</ion-label>
      </ion-item>

      <ion-item
        *ngIf="moreVM?.showTv360 && trendviewFeatureFlagEnabled"
        class="btm-line"
        data-cy="more-actions-list-item-trendview-360"
        (click)="routeToTrendview360()"
      >
        <ion-label>{{ 'i18n.moxe-links.tv360' | translate }}</ion-label>
        <ion-icon
          src="assets/icon/external-link-green.svg"
          class="external-link"
          slot="end"
        ></ion-icon>
      </ion-item>

      <ion-item
        *ngIf="baselineFeatureFlagEnabled"
        [disabled]="!hasBaselineAccess"
        class="btm-line"
        data-cy="more-actions-list-item-baseline"
        (click)="routeToBaseline()"
      >
        <ion-label
          >{{ 'i18n.moxe-links.accessBaseline' | translate }}</ion-label
        >
        <ion-icon
          src="assets/icon/external-link-green.svg"
          class="external-link"
          slot="end"
        ></ion-icon>
      </ion-item>
    </div>
  </ion-list>
</ion-content>
<app-footer></app-footer>
